import axios from "@/axios";

export const namespaced = true

export const state = {
    countries: [],
    agreementCountries: [],
    activeCountries: [],
    activePartnerCountries: [],
    countryTwoCharacterCode: []
}

export const getters = {
    allCountries: function (state) {
        return state.countries;
    },
    partnerNationCountries: function(state){
        if(state.countries){
            return state.countries.filter((country) => {
                return country.isPartnerNationApproval
              })
        }
    },
    agreementCountries: function (state) {
        return state.agreementCountries;
    },
    activeCountries: function (state) {
        return state.activeCountries;
    },
    activePartnerCountries: function (state) {
        return state.activePartnerCountries;
    },
    countryTwoCharacterCodes: function (state) {
        return state.countryTwoCharacterCode;
    }
}
    
export const mutations = {
    SET_COUNTRIES(state, resp) {
        state.countries = resp.data;
    },
    SET_AGREEMENT_COUNTRIES(state, resp) {
        state.agreementCountries = resp.data;
    },
    SET_ACTIVE_COUNTRIES(state, resp) {
        state.activeCountries = resp.data;
    },
    SET_ACTIVE_PARTNER_COUNTRIES(state, resp) {
        state.activePartnerCountries = resp.data;
    },
    SET_COUNTRIES_TWO_CHARACTER_NAME(state, resp) {
        state.countryTwoCharacterCode = resp.data;
    }
}

export const actions = {
    async getAllCountries({ commit, state }) {
            try {
                const response = await axios.get("/api/countries");
                commit('SET_COUNTRIES', response);
            } catch (error) {
                console.log("ERROR: ", error); //not handelled
            }
    },
    async getAllCountryTwoCharacterCode({ commit, state }, includePartnerNation) {
        try {
            const response = await axios.get(`/api/countries/two/character/code/${includePartnerNation}`, { config: { showToast: false } });
            commit('SET_COUNTRIES_TWO_CHARACTER_NAME', response);
        } catch (error) {
            console.log("ERROR: ", error); //not handelled
        }
    },  
    async getAllActiveCountries({ commit, state }) {
        try {
            const response = await axios.get("/api/countries/active", { config: { showToast: false } });
            commit('SET_ACTIVE_COUNTRIES', response);
        } catch (error) {
            console.log("ERROR: ", error); //not handelled
        }
    },  
    async getAllActivePartnerCountries({ commit, state }) {
        try {
            const response = await axios.get("/api/countries/active/partner", { config: { showToast: false } });
            commit('SET_ACTIVE_PARTNER_COUNTRIES', response);
        } catch (error) {
            console.log("ERROR: ", error); //not handelled
        }
    },  
    async getAgreementCountries({ commit, state }) {
            try {
                const response = await axios.get("/api/countries/agreements");
                commit('SET_AGREEMENT_COUNTRIES', response);
            } catch (error) {
                throw error;
                console.log("ERROR: ", error); //not handelled
            }
    }
}
